import React, { Component } from "react";
import PropTypes from "prop-types";

class FormError extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showError: false,
        };
    }

    static propTypes = {
        type: PropTypes.string,
        messages: PropTypes.array,
    };

    /**
     * Depending on the type of snack bar we may have specific text and settings/options.
     * In a default type of snackbar (with no type prop passed in, just text), we timeout instead like a toast would.
     */
    componentDidMount() {
        const { type, messages } = this.props;

        switch (type) {
            case "error":
                if (messages.length <= 0) {
                    messages.push("An unexpected error has occurred.");
                }
                break;
            case "warning":
                // todo - yellow, different icon?
                break;
            case "success":
            // todo - green, different icon
        }
    }

    renderIcon = () => {
        const { type } = this.props;

        switch (type) {
            case "error":
                return <i className="material-icons">error_outline</i>;
            case "warning":
                return <i className="material-icons">warning</i>;
            case "success":
                return <i className="material-icons">check_circle_outline</i>;
        }
    };

    render() {
        const { type, messages } = this.props;

        return (
            <div className={`form-error-container ${type}`}>
                {this.renderIcon()}
                <div className="form-messages">
                    {messages.map((message, index) => (
                        <div key={index}>
                            <p>{message}</p>
                        </div>
                    ))}
                </div>
            </div>
        );
    }
}

export default FormError;
